module.exports = __webpack_public_path__ + "static/media/truck_active.c6cd1a2f.svg";